export class UsuarioParametrizado{
    login: string;
    nombre: string;
    email: string;
    codigoSucursal: number;
    nombreSucursal: string;
    codigoArea: number;
    nombreArea: string;
    codigoCargo: number;
    descripcionCargo: string;
    codigoUsuarioSISE: string;
    activo: boolean;
    existe: boolean;
    fecha: string;

    static crearUsuario(login: string,
                        nombre: string,
                        email: string,
                        codigoSucursal: number,
                        nombreSucursal: string,
                        codigoArea: number,
                        nombreArea: string,
                        codigoCargo: number,
                        descripcionCargo: string,
                        existe: boolean,
                        fecha: string,
                        codigoUsuarioSISE: string,
                        estado: number){
        let usuario=new UsuarioParametrizado();
        usuario.login=login;
        usuario.nombre=nombre;
        usuario.email=email;
        usuario.codigoSucursal=codigoSucursal;
        usuario.nombreSucursal=nombreSucursal;
        usuario.codigoArea=codigoArea;
        usuario.nombreArea=nombreArea;
        usuario.codigoCargo=codigoCargo;
        usuario.descripcionCargo=descripcionCargo;
        usuario.activo=(Math.abs(estado)==1)?true:false;
        usuario.existe=existe;
        usuario.fecha=fecha;
        usuario.codigoUsuarioSISE=codigoUsuarioSISE;
        return usuario;
    }
}

